import i18n from 'i18next';

import getAdHocLetters from '../helpers/getAdHocLetters';

export default ({ hasCreateLetterAccess = false }) => ({
  ...(hasCreateLetterAccess && {
    radioOptions: {
      type: 'Radio',
      options: [
        { label: i18n.t('template'), value: 'template' },
        { label: i18n.t('custom'), value: 'custom' },
      ],
    },
  }),
  subject: {
    type: 'Text',
    label: i18n.t('subject'),
    validators: [{ type: 'isRequired' }],
    conditions: [{ type: 'isTemplate', shouldHideField: true }],
  },
  is_html: {
    labelText: i18n.t('use-html-editor'),
    type: 'Boolean',
    conditions: [{ type: 'isTemplate', shouldHideField: true }],
  },
  body: {
    label: i18n.t('body'),
    type: 'TextArea',
    conditions: [
      { type: 'isTemplate', shouldHideField: true },
      { type: 'isHtmlEditorChecked', shouldHideField: true },
    ],
    validators: [{ type: 'isRequired' }],
  },
  html: {
    label: i18n.t('body'),
    type: 'Tiptap',
    conditions: [
      { type: 'isTemplate', shouldHideField: true },
      { type: 'isHtmlEditorUnchecked', shouldHideField: true },
    ],
    validators: [{ type: 'isRequired' }],
  },
  letter_id: {
    type: 'AutoCompleteSearch',
    isSingleSelect: true,
    handleLoadOptions: getAdHocLetters,
    selectProps: {
      ariaLabel: i18n.t('choose-letter'),
      menuPosition: 'fixed',
      placeholder: i18n.t('choose-letter'),
    },
    conditions: [{ type: 'isCustomAdhocLetter', shouldHideField: true }],
  },
  dynamicVariables: {
    type: 'DynamicVariables',
    isDecoration: true,
    conditions: [{ type: 'isTemplate', shouldHideField: true }],
  },
});
